import arrayBufferToImage from './arrayBufferToImage';
import binaryToArrayBuffer from './binaryToArrayBuffer';

// ----------------------------------------------------------------------------

async function binaryToImage(binary: string): Promise<any> {
    // Binary To ArrayBuffer
    const arrayBuffer = binaryToArrayBuffer(binary);

    // ArrayBuffer To Image
    const elImage = arrayBufferToImage(arrayBuffer);

    // Return
    return elImage;
}

// ----------------------------------------------------------------------------

export default binaryToImage;
